import { DeviceType } from '@/graphql/generated/schemas'

import { ConnectionI } from '../../types/types'

/**
 * Resolves the connection state to i18n keys. Mirrors getPopOverTitle and
 * TailgatePopoverBody, whose copy is hardcoded English — the branches and their
 * order are kept identical so the dark card says the same thing the legacy one
 * does, and the branch order matters: tailgate-enabled outranks
 * grid-configured, which outranks a plain association.
 */
export const getTailgatePopoverCopy = (connection: ConnectionI) => {
  if (connection?.isTailgateEnabled) {
    return {
      titleKey: 'floors:tailgate_popover_title_enabled',
      bodyKeys: [
        'floors:tailgate_popover_associated_enabled',
        'floors:tailgate_popover_edit_mode_view_or_edit',
      ],
    } as const
  }
  if (connection?.isTailgateGridConfigured) {
    return {
      titleKey: 'floors:tailgate_popover_title_grid_configured',
      bodyKeys: [
        'floors:tailgate_popover_associated_grid_configured',
        'floors:tailgate_popover_edit_mode_view_or_edit',
      ],
    } as const
  }
  if (connection?.deviceType === DeviceType.Alarm && connection?.isConnected) {
    return {
      titleKey: 'floors:tailgate_popover_title_associated',
      bodyKeys: ['floors:tailgate_popover_alarm_associated'],
    } as const
  }
  if (connection?.isConnected) {
    return {
      titleKey: 'floors:tailgate_popover_title_awaiting_grid',
      bodyKeys: [
        'floors:tailgate_popover_detection_not_enabled',
        'floors:tailgate_popover_detection_pending_grid',
        'floors:tailgate_popover_edit_mode_configure',
      ],
    } as const
  }
  return {
    titleKey: 'floors:tailgate_popover_title_ready',
    bodyKeys: [
      'floors:tailgate_popover_in_view_not_associated',
      'floors:tailgate_popover_associating_attaches_clips',
      'floors:tailgate_popover_edit_mode_associate',
    ],
  } as const
}
